// extracted by mini-css-extract-plugin
export default {"option":"RemovableSelect_option__izdZy","selected":"RemovableSelect_selected__H7zYN"};